<template lang="pug">
div
  v-menu(
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :disabled="isReadonly || isDisabled"
    transition="scale-transition"
    offset-y
    origin="top right"
    left
    min-width="auto"
    @input="tab = 0"
  )
    template(#activator="{ on, attrs }")
      v-text-field(
        v-bind="attrs"
        v-model="datetime"
        filled
        :class="{ 'x-widget-readonly': isReadonly }"
        :dense="!isLarge"
        :label="myTitle"
        :hint="myHint"
        :hide-details="hasNoHints"
        :prepend-inner-icon="myIcon"
        :rules="rules"
        :append-icon="(isReadonly || isDisabled) ? null : 'mdi-calendar'"
        :outlined="isOutlined"
        :readonly="isReadonly"
        :required="isRequired && !isDisabled"
        :disabled="isDisabled"
        :placeholder="myPlaceholder"
        @blur="commit"
        @keydown.enter="e => $emit('actionPerformed', e)"
      )
        //- @click:append="on.click"

    template
      v-tabs(v-if="menu" v-model="tab" height="50" grow)
        v-tab(@click="resetTimePicker" style="min-width: 145px;")
          template
            .text-h6 {{ formatDate(date) || '-- / -- / --' }}

        v-tab(@click="resetTimePicker")
          template
            .text-h6 {{ time || '-- : -- : --' }}

      v-tabs-items(v-if="menu" v-model="tab")
        v-tab-item
          v-date-picker.x-widget-date-time--date-picker(
            v-if="menu"
            v-model="date"
            no-title
            scrollable
            show-adjacent-months
            locale="pt-br"
            filled
            @input="tab = 1"
          )
            v-spacer

            v-tooltip(bottom)
              template(#activator="{ on, attrs }")
                v-btn(
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="primary"
                  @click="tab = 1"
                )
                  v-icon mdi-arrow-right
              span
                span.font-weight-light Avançar

        v-tab-item
          v-time-picker(
            ref="timePicker"
            v-if="menu"
            no-title
            v-model="time"
            scrollable--sq
            format="24hr"
            locale="pt-br"
            use-seconds
            filled
            @click:second="menu = null"
          )
            v-tooltip(bottom)
              template(#activator="{ on, attrs }")
                v-btn(
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="primary"
                  @click="resetTimePicker('selectingHour')"
                )
                  .text-outline H
              span
                span.font-weight-light Editar a hora

            v-tooltip(bottom)
              template(#activator="{ on, attrs }")
                v-btn(
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="primary"
                  @click="resetTimePicker('selectingMinute')"
                )
                  .text-outline M
              span
                span.font-weight-light Editar os minutos

            v-tooltip(bottom)
              template(#activator="{ on, attrs }")
                v-btn(
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="primary"
                  @click="resetTimePicker('selectingSecond')"
                )
                  .text-outline S
              span
                span.font-weight-light Editar os segundos

            v-spacer

            v-tooltip(bottom)
              template(#activator="{ on, attrs }")
                v-btn(
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="primary"
                  @click="menu = null"
                )
                  v-icon mdi-check
              span
                span.font-weight-light Confirmar

</template>

<style scoped>
.x-widget-date-time--date-picker .v-date-picker-title__year {
  display: none;
}
</style>

<script>
import {
  getISODate,
  getISODateTime,
  getDate,
  getDateTime,
  getTime,
  isValidDateTime,
} from '@/helpers/dates';

export default {
  props: {
    /**
     * Objeto contendo os valores e campos do contexto no qual o widget está
     * inserido para inferência de propriedades aplicadas em interpolação de
     * templates de texto.
     */
    context: Object,

    /**
     * Instância opcional de um campo do Paper.
     * @type {Keep.Paper.Design.Field}
     */
    field: Object,

    /**
     * Um dos tipos de dados suportados pelo Paper.
     * @type {Keep.Paper.Design.TypeNames}
     */
    dataType: String,

    /**
     * Diz se o componente suporta seleção de intervalo.
     * @type {Boolean}
     */
    allowRange: Boolean,

    /**
     * Valor editado no componente.
     * @type {Any}
     */
    value: {
      validator: (v) => true,
    },
  },

  data: () => ({
    tab: null,
    menu: null,
    datetime: null,
  }),

  computed: {
    // myName: vm => vm.getIt('name'),
    myTitle: (vm) => vm.getIt("title") || vm.myName,
    mySubtitle: (vm) => vm.getIt("subtitle"),
    myDescription: (vm) => vm.getIt("description"),
    myHint: (vm) => vm.getIt("hint") || vm.mySubtitle,
    myPlaceholder: (vm) => vm.getIt("placeholder"),
    myIcon: (vm) => vm.getIt("icon"),
    hasNoHints: (vm) => vm.hasIt("noHints"),
    isLarge: (vm) => vm.hasIt("large"),
    isDisabled: (vm) => vm.hasIt("disabled"),
    isRequired: (vm) => vm.hasIt("required"),
    isReadonly: (vm) => vm.hasIt("readOnly") || vm.hasIt("readonly"),
    isOutlined: (vm) => vm.hasIt("outlined"),

    // Valor real recebido e devolvido pelo widget.
    content: {
      get() {
        return getISODateTime(this.value)
      },
      set(value) {
        // this.$emit("input", value)
      },
    },

    date: {
      get() {
        return getISODate(this.content)
      },
      set(value) {
        // this.content = getISODateTime(`${value}T${this.time}`, true)
      },
    },

    time: {
      get() {
        return getTime(this.content)
      },
      set(value) {
        // this.content = getISODateTime(`${this.date}T${value}`, true)
      },
    },

    rules() {
      const required = this.isRequired && !this.isDisabled
      const rules = {
        required: (v) => !required || !!v || "Campo requerido",
        validDate: (v) => isValidDateTime(v) || "Data inválida.",
      }
      return [rules.required, rules.validDate]
    },
  },

  methods: {
    formatDate(date) {
      return getDate(date)
    },

    resetTimePicker(part) {
      this.$nextTick(() => {
        if (this.$refs.timePicker) {
          this.$set(this.$refs.timePicker, part || 'selectingHour', true)
        }
      })
    },

    getIt(property) {
      return (
        this[property] ||
        this.$props[property] ||
        this.$attrs[property] ||
        this.field?.[property]
      )
    },
    hasIt(property) {
      if (this.$props[property] === "") return true
      if (this.$attrs[property] === "") return true
      const value =
        this[property] ||
        this.$props[property] ||
        this.$attrs[property] ||
        this.field?.[property]
      return !!value
    },

    commit() {
      const datetime = getISODateTime(this.datetime)
      if (datetime !== this.content) {
        this.$nextTick(() => this.datetime = datetime)
      }
    },

    restore() {
      this.datetime = getDateTime(this.content)
    },
  },

  mounted() {
    this.restore()
  },

  watch: {
    value: "restore",
  },
}
</script>
